import * as APITypes from "~/API";
import type { UnitListFilters } from "~/types";

export function parseUnitListFilters(
  searchParams: URLSearchParams,
): UnitListFilters {
  const filters: UnitListFilters = {};

  const statusRaw = searchParams.get("status");
  if (
    statusRaw &&
    (Object.values(APITypes.UnitStatusType) as string[]).includes(statusRaw)
  ) {
    filters.status = statusRaw as APITypes.UnitStatusType;
  }

  const numBedroom = searchParams.get("numBedroom")?.trim();
  if (numBedroom) {
    filters.numBedroom = numBedroom;
  }

  const numBathroom = searchParams.get("numBathroom")?.trim();
  if (numBathroom) {
    filters.numBathroom = numBathroom;
  }

  const propertyId = searchParams.get("propertyId")?.trim();
  if (propertyId) {
    filters.propertyId = propertyId;
  }

  return filters;
}
